var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 4.875V3.375H7.5V4.875H10.5ZM3 6.375V14.625H15V6.375H3ZM15 4.875C15.8325 4.875 16.5 5.5425 16.5 6.375V14.625C16.5 15.4575 15.8325 16.125 15 16.125H3C2.1675 16.125 1.5 15.4575 1.5 14.625L1.5075 6.375C1.5075 5.5425 2.1675 4.875 3 4.875H6V3.375C6 2.5425 6.6675 1.875 7.5 1.875H10.5C11.3325 1.875 12 2.5425 12 3.375V4.875H15Z",
    fill: "#008F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/Work.dded24bd02f60b93cab45e1efef2b96f.svg";
export { ForwardRef as ReactComponent };